var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-tabs',{attrs:{"inline-label":"","active-color":"primary","indicator-color":"primary"}},_vm._l((_vm.tabs_data),function(tab){return _c('q-route-tab',{key:tab.path,attrs:{"name":tab.name,"label":_vm.$q.screen.gt.xs ? tab.name : tab.short_name,"to":tab.path}})}),1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }